import { createIcon } from "@chakra-ui/react";

export const FilterIcon = createIcon({
  displayName: "FilterIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 6.875H4V5.125H12V6.875Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1348 17.1431L20.1348 17.1431V18.8931L12.1348 18.8931V17.1431Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 6.875L16 6.875V5.125L20 5.125V6.875Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 17.125H8V18.875H4L4 17.125Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 12.875H4V11.125H20V12.875Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 7.5C14.8284 7.5 15.5 6.82843 15.5 6C15.5 5.17157 14.8284 4.5 14 4.5C13.1716 4.5 12.5 5.17157 12.5 6C12.5 6.82843 13.1716 7.5 14 7.5ZM14 9C15.6569 9 17 7.65685 17 6C17 4.34315 15.6569 3 14 3C12.3431 3 11 4.34315 11 6C11 7.65685 12.3431 9 14 9Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.1348 16.5176C9.30634 16.5176 8.63477 17.1892 8.63477 18.0176C8.63477 18.846 9.30634 19.5176 10.1348 19.5176C10.9632 19.5176 11.6348 18.846 11.6348 18.0176C11.6348 17.1892 10.9632 16.5176 10.1348 16.5176ZM10.1348 15.0176C8.47791 15.0176 7.13477 16.3607 7.13477 18.0176C7.13477 19.6744 8.47791 21.0176 10.1348 21.0176C11.7916 21.0176 13.1348 19.6744 13.1348 18.0176C13.1348 16.3607 11.7916 15.0176 10.1348 15.0176Z"
        fill="currentColor"
      />
    </>
  ),
});
